<template>
	<div class="role-page" v-loading="loading">
	  <div class="con-body">
		<div class="control-group">
		  <div class="group-left">
			<el-button
			  type="primary"
			  size="small"
			  @click="openEditWin('create')"
			  class="insert-btn"
			  ><svg-icon name="add-plus"></svg-icon>{{$t('control.add')}}</el-button
			>
		  </div>
		</div>
		<el-table :data="tableData" style="width: 100%">
		  <el-table-column prop="role_id" label="ID" width="100"></el-table-column>
		  <el-table-column prop="role_name" :label="$t('manage.company')"></el-table-column>
		  <el-table-column prop="logo" :label="$t('manage.company_logo')"></el-table-column>
		  <el-table-column prop="title" :label="$t('manage.title')"></el-table-column>
		  <el-table-column prop="created_at" :label="$t('screen.add_time')"></el-table-column>
		  <el-table-column prop="edit" :label="$t('control.operate')" width="100">
			<template slot-scope="scope">
			  <div class="edit-button">
				<i
				  @click="openEditWin(scope.row)"
				  class="el-icon-edit pointer mar-r10"
				></i>
				<i
				  class="el-icon-delete pointer"
				  @click="delItem(scope.row.role_id)"
				></i>
			  </div>
			</template>
		  </el-table-column>
		</el-table>
		<el-pagination
		  @size-change="handleSizeChange"
		  @current-change="handleCurrentChange"
		  :current-page="pageInfo.page"
		  :page-sizes="[10, 20, 30, 40, 50, 100]"
		  :page-size="pageInfo.pageSize"
		  layout="sizes, total, prev, pager, next, jumper"
		  :total="cnt_all"
		>
		</el-pagination>
	  </div>
	  <!--新增对话框-->
	  <el-dialog
		class="dialog750"
		:title="editType === 'create' ? '添加公司' : '修改公司'"
		:visible.sync="dialogVisible"
		v-if="dialogVisible"
	  >
		<el-form
		  :model="editOne"
		  :rules="editOneRule"
		  ref="dialogRef"
		>
		  <div class="form-info">
			<el-form-item :label="$t('manage.company')" prop="role_name">
			  <el-input v-model="editOne.role_name"></el-input>
			</el-form-item>
			<el-form-item :label="$t('manage.company_logo')" prop="logo">
			  <el-input v-model="editOne.logo"></el-input>
			</el-form-item>
			<el-form-item :label="$t('manage.title')" prop="title">
			  <el-input v-model="editOne.title"></el-input>
			</el-form-item>
			<div class="address-box">
			  <el-row>
				<el-form-item :label="$t('manage.province')" prop="province_id">
				  <el-select v-model="editOne.province_id" :placeholder="$t('manage.province')" @change="getCity" style="width: 120px" size="small">
					<el-option
					  v-for="(item,index) of addressObj.provinceArr"
					  :key="index"
					  :label="item.area_name"
					  :value="item.area_id"
					  ></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('manage.city')" prop="city_id">
				  <el-select v-model="editOne.city_id" :placeholder="$t('manage.city')" @change="getArea" style="width: 120px" size="small">
					<el-option
					  v-for="(item,index) of addressObj.cityArr"
					  :key="index"
					  :label="item.area_name"
					  :value="item.area_id"
					  ></el-option>
				  </el-select>
				</el-form-item>
				<el-form-item :label="$t('manage.area')" prop="district_id">
					<el-select v-model="editOne.district_id" :placeholder="$t('manage.area')" style="width: 120px" size="small">
					  <el-option
						v-for="(item,index) of addressObj.areaArr"
						:key="index"
						:label="item.area_name"
						:value="item.area_id"
					  ></el-option>
					</el-select>
				</el-form-item>
			  </el-row>
			</div>
		  </div>
		</el-form>
		<div slot="footer" class="dialog-footer">
		  <el-button class="mw-edit-button" @click="dialogVisible = false"
			>{{$t('control.cancel')}}</el-button
		  >
		  <el-button
			type="primary"
			@click="createItem"
			v-if="editType === 'create'"
			>{{$t('control.confirm')}}</el-button
		  >
		  <el-button
			type="primary"
			@click="updateItem"
			v-if="editType === 'update'"
			>{{$t('control.confirm')}}</el-button
		  >
		</div>
	  </el-dialog>
	</div>
  </template>
  
  <script>
  import roleApi from "@/api/system/role";
  import publicApi from "@/api/system/public";
  export default {
	data() {
	  return {
		loading: false,
		dialogVisible: false,
		tableData: [],
		pageInfo: {
		  sortBy: 'role_id',
		  descending: 'desc',
		  filter: '',
		  page: 1,
		  pageSize: 10
		},
		cnt_all: 0,
		editOneRule: {
		  role_name: [{ required: true, message: this.$t('manage.please_company'), trigger: "blur" }],
		  title: [{ required: true, message: this.$t('manage.title'), trigger: "blur" }]
		},
		editType: -1,
		editOne: {
		  role_id: '',
		  role_name: '',
		  logo: '',
		  title: '',
		  province_id: '',
		  city_id: '',
		  district_id: ''
		},
		addressObj: {
		  provinceArr: [],
		  cityArr: [],
		  areaArr: []
		}
	  };
	},
	async created() {
	  await this.getProvince()
	  this.getTableData(this.pageInfo.page)
	},
	methods: {
	  // 获取省份列表
	  async getProvince() {
		await publicApi.getProvinceList().then((res) => {
		  if (res.data.code === 1000) {
			this.addressObj.provinceArr = res.data.data
			this.editOne.province_id =''
			if(this.addressObj.provinceArr.length){
			  this.getCity(this.addressObj.provinceArr[0].area_id)
			}
		  }
		})
	  },
	  // 获取城市列表
	  getCity(id) {
		publicApi.getCityList({
		  province: id
		}).then((res) => {
		  if (res.data.code === 1000) {
			this.addressObj.cityArr = res.data.data
			this.editOne.city_id =''
			if(this.addressObj.cityArr.length){
			  this.getArea(this.addressObj.cityArr[0].area_id)
			}
		  }
		})
	  },
	  // 获取城市列表
	  getArea(id) {
		publicApi.getAreaList({
			city: id
		  }).then((res) => {
		  if (res.data.code === 1000) {
			this.addressObj.areaArr = res.data.data
			this.editOne.district_id =''
		  }
		})
	  },
	  // 获取列表
	  getTableData(pageIndex) {
		this.loading = true;
		this.pageInfo.page = pageIndex;
		const filter = JSON.stringify(this.pageInfo.filter);
		let pageFilter = this.pageInfo
		pageFilter.filter = filter
		roleApi.getrole(pageFilter).then((res) => {
		  if (res.data.code === 1000) {
			this.loading = false;
			let resData = res.data.data;
			this.tableData = resData.list;
			this.pageInfo.page = pageIndex;
			this.cnt_all = parseInt(resData.count);
		  }
		});
	  },
	  handleSizeChange(val) {
		this.pageInfo.pageSize = val;
		this.getTableData(this.pageInfo.page);
	  },
	  handleCurrentChange(val) {
		this.pageInfo.page = val;
		this.getTableData(this.pageInfo.page);
	  },
	  openEditWin(index) {
		if (index === "create") {
		  this.editOne = {
			role_id: '',
			role_name: '',
			logo: '',
			title: '',
			province_id: '',
			city_id: '',
			district_id: ''
		  };
		  this.editType = "create";
		} else {
		  this.editOne = {
			role_id: index.role_id,
			role_name: index.role_name,
			logo: index.logo,
			title: index.title,
			province_id: index.province_id,
			city_id: index.city_id,
			district_id: index.district_id
		  }
		  if(index.province_id){
			this.getCity(index.province_id)
		  }
		  this.editType = "update";
		}
		this.dialogVisible = true;
	  },
  
	  updateItem() {
		this.$refs["dialogRef"].validate((valid) => {
		  if (valid) {
			roleApi.roleEdit(this.editOne.role_id, this.editOne).then((res) => {
			  if (res.data.code === 1000) {
				this.$message.success(this.$t('control.mod_success'));
				this.dialogVisible = false;
				this.getTableData(this.pageInfo.page);
			  } else {
				this.$message.error(res.data.message);
			  }
			});
		  }
		});
		
	  },
	  createItem() {
		this.$refs["dialogRef"].validate((valid) => {
		  if (valid) {
			roleApi.roleAdd(this.editOne).then((res) => {
			  if (res.data.code === 1000) {
				this.$message.success(this.$t('control.add_success'));
				this.dialogVisible = false;
				this.getTableData(this.pageInfo.page);
			  } else {
				this.$message.error(res.data.message);
			  }
			});
		  }
		});
		
	  },
	  delItem(id) {
		this.$confirm(this.$t('manage.del_tip'), this.$t('control.tip'), {
		  confirmButtonText: this.$t('control.confirm'),
		  cancelButtonText: this.$t('control.cancel'),
		  type: "warning",
		})
		  .then(() => {
			roleApi.projectDel(id).then((res) => {
			  if (res.data.code === 1000) {
				this.$message.success(this.$t('control.del_success'));
				this.getTableData(this.pageInfo.page);
			  } else {
				this.$message.error(res.data.message);
			  }
			});
		  })
		  .catch(() => {
			this.$message({
			  type: "info",
			  message: this.$t('control.cancel_del'),
			});
		  });
	  }
	}
  };
  </script>
  <style lang='less'>
  .role-page {
	width: 100%;
	.form-info{
	  padding-left: 8px;
	  .el-form-item__label{
		width:85px;
	  }
	}
  }
  </style>